import { useQuery } from '@tanstack/react-query'
import { mfaChallenge } from '@global/api'

export function useQueryMfaChallenge({ email, token }) {
  return useQuery({
    queryKey: ['mfaChallenge', email],
    queryFn: () => mfaChallenge({ email, mfa_token: token as string }),
    enabled: !!email && !!token,
    refetchOnWindowFocus: false,
  })
}
